import { UliActivityType } from '../../../../../../common/constants/uli';
import { Observable, Subject } from 'rxjs';

export class UliCreateServerMessageModel {
  organizationId: number;
  hubId: number;
  compartmentId: number;
  uli: string;
  type: UliActivityType;
  details?: string;
  message?: string;
}

export class UliCreatedAndAllocatedServerMessageModel {
  status: string;
  uliNumber: string;
  dockId: number;
  slotStart: string;
  slotEnd: string;
  reason: string;
}

export interface TopicStoreType {
  topic$: Observable<unknown>;
  unsubscribe$: Subject<boolean>;
}

export interface HubTopicParamsModel {
  hubId: number;
}

export interface LoadTopicParamsModel {
  hubId: number;
  loadNumber: string;
}

export interface UliTopicParamsModel {
  hubId: number;
  uliId: string;
}

export interface NotaFiscalServerMessageModel {
  nfVerificationId: number;
}
